// src/components/Footer.js
import React from 'react';
import './MainMenu.css';

const Footer = () => {
  return (
    <footer className="footer-full" style={{ backgroundImage: "url('/footer-bg.jpg')" }}>
      <div className="footer-overlay">
        <div className="footer-columns">

          <div className="footer-col">
            <h4>Reach Us</h4>
            <p><i className="fas fa-map-marker-alt"></i> Universal Academy, Neravy, Karaikal</p>
            <p><i className="fas fa-phone-alt"></i> +91 94863 10015</p>
            <p><i className="fas fa-envelope"></i> universalacademy@gmail.com</p>
            <p><i className="fas fa-globe"></i> universalacademy.in</p>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/student-life">Student Life</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Follow Us</h4>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=100066771038800" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/universalacademykaraikal?igsh=bmlvZDEyZGo0N25n" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

        </div>

        <div className="footer-bottom-bar">
          © {new Date().getFullYear()} Universal Academy, Karaikal. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
